<template>
  <div class="SideMenu">
    <div class="SideMenu__bar">
      <div class="SideMenu__burger__wrapper">
        <div
        @click="collapse"
        class="SideMenu__burger"
        :class="{'SideMenu__burger--active': !collapsed}">
          <div class="SideMenu__burger__inner"/>
        </div>
      </div>
      <router-link
      tag="div"
      :to="{name: 'home'}">
        <SvgImage
        imageName="KCloudLogo"
        class="SideMenu__logo"/>
      </router-link>
    </div>
    <div
    class="SideMenu__wrapper scrollbar-container"
    :class="{'SideMenu__wrapper--active': !collapsed}">
      <ul class="SideMenu__list">
        <router-link
        tag="li"
        :to="{name: 'files'}"
        class="SideMenu__element"
        :class="{'SideMenu__element--active': isActiveTab('files')}">
          <SvgImage
          :imageName="imageName('files')"
          class="SideMenu__icon"/>
          <span>Files</span>
        </router-link>
        <router-link
        tag="li"
        :to="{name: 'media'}"
        class="SideMenu__element"
        :class="{'SideMenu__element--active': isActiveTab('media')}">
          <SvgImage
          :imageName="imageName('media')"
          class="SideMenu__icon"/>
          <span>Media</span>
        </router-link>
        <router-link
        tag="li"
        :to="{name: 'settings'}"
        class="SideMenu__element"
        :class="{'SideMenu__element--active': isActiveTab('settings')}">
          <SvgImage
          :imageName="imageName('settings')"
          class="SideMenu__icon"/>
          <span>Settings</span>
        </router-link>
      </ul>
      <div class="SideMenu__user">
        <span class="SideMenu__user__name">
          {{ userName }}
        </span>
        <div
        class="SideMenu__user__progress__wrapper">
          <div
          class="SideMenu__user__progress"
          :style="{ width: `${cloudStoragePercent}%` }"/>
        </div>
        <span class="SideMenu__user__usage">
          {{ cloudStoragePercent }}% of {{ cloudStorageAvailableGb }} GB used
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import UserMixin from '@/components/mixins/User.mixin'

export default {
  name: 'SideMenu',

  mixins: [
    UserMixin
  ],

  data () {
    return {
      collapsed: true
    }
  },

  computed: {
    currentPath () {
      return this.$route.path
    }
  },

  watch: {
    currentPath () {
      this.collapsed = true
    }
  },

  methods: {
    collapse () {
      this.collapsed = !this.collapsed
    },
    isActiveTab (page) {
      return this.currentPath.startsWith(`/${page}`)
    },
    imageName (page) {
      let iconName
      switch (page) {
        case 'files':
          iconName = 'SideMenuFolder'
          break
        case 'media':
          iconName = 'SideMenuMedia'
          break
        case 'settings':
          iconName = 'SideMenuSettings'
          break
      }
      return this.isActiveTab(page) ? `${iconName}Active` : iconName
    }
  }
}
</script>

<style lang="scss">
@import 'SideMenu';
</style>
